import { GameEvent } from 'types/components/GameEvent';

//Threshold 12 hours.
export const GAME_EVENTS_DAYS_THRESHOLD = 43200000; //ms

export const isAbleToMutateEvent = (data: GameEvent) => {
  const { startDate, published } = data;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const targetDate = new Date(startDate);
  targetDate.setHours(0, 0, 0, 0);
  return (
    !published || (published && targetDate.getTime() - now.getTime() > GAME_EVENTS_DAYS_THRESHOLD)
  );
};
